var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveChat = function SvgLiveChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 89 88"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.051,
    cy: 44,
    fill: "#D0006F",
    rx: 43.977,
    ry: 44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    clipPath: "url(#live-chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.388 42.333h1.481M43.31 42.333h1.482M49.234 42.333h1.481M41.62 29.833h5.823c3.077 0 6.027 1.223 8.203 3.4a11.6 11.6 0 0 1 3.397 8.206v.12a11.61 11.61 0 0 1-7.16 10.723 11.6 11.6 0 0 1-4.44.884H45.74a.022.022 0 0 0-.022.022v3.77a1.21 1.21 0 0 1-1.187 1.206 1.2 1.2 0 0 1-.6-.149l-8.363-4.602a12.56 12.56 0 0 1-6.508-11.012 12.58 12.58 0 0 1 3.68-8.887 12.56 12.56 0 0 1 8.882-3.681"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "live-chat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.062 24H64.04v40H24.06z"
  })))));
};
export default SvgLiveChat;